<script>
    import SimpleModal from 'svelte-simple-modal';
    import ModalContent from 'src/components/Modal/ModalContent.svelte';

    export let name = 'main';
    //note: don't pass options to Simple Modal but instead Modal Content
    //this way when somebody calls .open() with options they override these options
    //svelte-simple-modal doesn't do that
    export let options;

</script>

<SimpleModal >
    <ModalContent {name} {options} />
</SimpleModal>
